import React from "react";
import PropTypes from "prop-types";
import useExtensionSurfacePreviewState from "../shared/useExtensionSurfacePreviewState";
import ExtensionUpsellWidget from "../shared/ExtensionUpsellWidget";
import {
  DUMMY_CART_DRAWER_TOTAL,
  SURFACE_WIDGET_BADGES,
} from "../shared/extension-preview-dummy-data";
import styles from "./cart-drawer-editor-preview.module.css";

function CloseIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  );
}

function CartDrawerSkeletonLineItems() {
  return (
    <>
      {[0, 1].map((key) => (
        <div key={key} className={styles.skeletonLineItem} aria-hidden>
          <div className={styles.skeletonThumb} />
          <div className={styles.skeletonLines}>
            <div className={`${styles.skeletonBar} ${styles.skeletonBarWide}`} />
            <div className={`${styles.skeletonBar} ${styles.skeletonBarMid}`} />
            <div className={`${styles.skeletonBar} ${styles.skeletonBarShort}`} />
          </div>
        </div>
      ))}
    </>
  );
}

export default function CartDrawerEditorPreview({ popupData, popupState, setPopupState }) {
  const preview = useExtensionSurfacePreviewState({
    popupData,
    popupState,
    setPopupState,
  });

  return (
    <div
      ref={preview.popupRef}
      className={`${styles.pageShell} ${preview.isMobile ? styles.mobile : ""}`.trim()}
      data-testid="cart-drawer-upsell-preview"
      data-extension-surface="CART_DRAWER"
    >
      <header className={styles.drawerHeader}>
        <h1 className={styles.drawerTitle}>Your cart</h1>
        <button type="button" className={styles.closeBtn} aria-label="Close cart">
          <CloseIcon />
        </button>
      </header>

      <div className={styles.drawerBody}>
        <div className={styles.widgetSlot}>
          <ExtensionUpsellWidget
            surfaceBadge={SURFACE_WIDGET_BADGES.CART_DRAWER}
            variant="cart-drawer"
            mapped={preview.mapped}
            popupData={popupData}
            activeStep={preview.activeStep}
            currentParentData={preview.currentParentData}
            selectedBlock={preview.selectedBlock}
            handleBlockClick={preview.handleBlockClick}
            isSelected={preview.isSelected}
            renderCta={preview.renderCta}
          />
        </div>

        <section className={styles.cartItemsSection} aria-label="Cart items preview">
          <div className={styles.columnHeaders}>
            <span>Product</span>
            <span>Total</span>
          </div>
          <CartDrawerSkeletonLineItems />
        </section>
      </div>

      <footer className={styles.drawerFooter}>
        <div className={styles.footerTotalRow}>
          <span>Estimated total</span>
          <strong>{DUMMY_CART_DRAWER_TOTAL}</strong>
        </div>
        <p className={styles.footerNote}>
          Taxes, discounts and shipping calculated at checkout.
        </p>
        <button type="button" className={styles.checkoutBtnSkeleton}>
          Check out
        </button>
      </footer>
    </div>
  );
}

CartDrawerEditorPreview.propTypes = {
  popupData: PropTypes.object,
  popupState: PropTypes.object,
  setPopupState: PropTypes.func,
};
